/** The panel's explanation block: one shape, two tones. Its own module so the drawer and the
 *  technician search can both read it without importing each other. */
const HELP_BASE =
  'flex gap-2.5 rounded-xl border border-zinc-200 p-3 text-[12.5px] leading-relaxed dark:border-zinc-800';

/** Neutral: says what has to happen next. */
export const HELP = `${HELP_BASE} text-muted-foreground`;

/** Same block, for a state that blocks the send. */
export const HELP_ALERT = `${HELP_BASE} text-rose-700 dark:text-rose-400`;

/** A technician's skill, as a tag. Shared so the ranked list and the search read as one family. */
export const SKILL_TAG =
  'inline-block h-[22px] max-w-full truncate rounded-[6px] bg-zinc-100 px-2 text-xs font-medium leading-[22px] text-foreground dark:bg-zinc-800';

/** The count after the visible tags, the shape the missions table already draws. */
export const SKILL_MORE =
  'inline-flex h-[22px] items-center rounded-full bg-zinc-100 px-2 text-[11.5px] font-semibold text-muted-foreground dark:bg-zinc-800';
